module.exports = __webpack_public_path__ + "static/ChatMobile-13fdfa3a64d7bae14c4458092fe8de21.mp4";